module.exports = __webpack_public_path__ + "img/cover3.983e294f.jpeg";